<template>
  <div id="contents-container">
    <MainCard></MainCard>
    <div class="body-without-main-card">
      <Cards/>
      <Services/>
      <EventGallery></EventGallery>
    </div>
  </div>
</template>

<script>
import HomeCard from "./HomeCard";
import MainCard from "@/components/MainCard.vue";
import Cards from "@/components/Cards.vue";
import Services from "@/components/Services.vue";
import EventGallery from "@/components/EventGallery.vue";

export default {
  components: {
    EventGallery,
    Services,
    Cards,
    MainCard,
    HomeCard
  },
};
</script>

<style scoped lang="scss">
h5 {
  margin-top: 1em;
}

#home-container {
  background: #000000; /* For browsers that don't support gradients */
}

#contents-container {
  background: #000000; /* For browsers that don't support gradients */
  padding: 0 0 1% 0;
}

/* Hide scrollbar globally */
#contents-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@-webkit-keyframes slideInLeft {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

@keyframes slideInLeft {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
    visibility: visible;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

.body-without-main-card {
  //padding: 0 10% 0;
  padding: 5% 10% 5%;
}

@media screen and (min-width: 1024px) {
  .body-without-main-card {
    padding: 5% 15% 5%;
  }
}

/* Extra small devices (phones, 600px and down)*/
@media only screen and (max-width: 600px) {
  #contents-container {
    margin-top: 15% !important;
  }
}

</style>
